module.exports = __webpack_public_path__ + "img/phone.584f89de.svg";